import { MaskedElement } from '@afterpaytouch/integrations/MaskedElement'
import { ModuleContainer } from '../ModuleContainer'
import { useIsDesignLanguage, DesignLanguage } from '@afterpaytouch/core'
import FormBuilder, { FormBuilderRef, Schema } from '@afterpaytouch/form'
import { ThreeDS } from '../ThreeDS'
import { NewPaymentMethodFormSchema } from './types'
import React, { FC } from 'react'

interface AddCardFormProps {
  showApplePay: boolean
  formRef: React.RefObject<FormBuilderRef>
  schema: Schema<NewPaymentMethodFormSchema>
  handleOnChange: (data: NewPaymentMethodFormSchema) => void
  onSubmit?: (data: NewPaymentMethodFormSchema) => Promise<void>
  submitted: boolean
  threeDSIframeURL: string
  showThreeDSIframe: boolean
  threeDSOnClose: () => void
  showModalCloseButton: boolean
}

export const AddCardForm: FC<AddCardFormProps> = ({
  showApplePay,
  formRef,
  schema,
  handleOnChange,
  onSubmit,
  submitted,
  showThreeDSIframe,
  threeDSIframeURL,
  showModalCloseButton,
  threeDSOnClose,
}) => {
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  let paddingStyle
  if (isArcadeDesignLanguage && showApplePay) {
    paddingStyle = { top: 'Large' }
  } else if (isArcadeDesignLanguage) {
    paddingStyle = 'None'
  } else {
    paddingStyle = { vertical: 'Large', horizontal: 'XLarge' }
  }

  return (
    <>
      <ModuleContainer nested padding={paddingStyle}>
        <MaskedElement actionName='New Payment Method Form'>
          <FormBuilder ref={formRef} schema={schema} onChange={handleOnChange} onSubmit={onSubmit} disabled={submitted} />
        </MaskedElement>
        <ThreeDS challengeURL={threeDSIframeURL} show={showThreeDSIframe} onClose={threeDSOnClose} showCloseButton={showModalCloseButton} />
      </ModuleContainer>
    </>
  )
}
